import axios from 'axios';

export function createAxios() {
  return axios.create({
    headers: {
      Pragma: 'no-cache',
    },
  });
}



// WEBPACK FOOTER //
// ./src/shared/api/apiClient.tsx